import $ from  'jquery'

export function fillSvg (){
    $('svg style').text('.cls-1 {fill: #fff}')
    $('svg').animate({height:'95%'}, 100)
    $('svg').animate({height:'100%'}, 100)
}

//Animação do texto incial
$(document).ready(function () {
    $('.anim-up').addClass('final-position')
    
    setTimeout(() => {
      $('.anim-left').addClass('final-position')
    }, 500);

    setTimeout(() => {
      $('.anim-right').addClass('final-position')    
    }, 1500);
})